// extracted by mini-css-extract-plugin
export var addButton = "_j6-0";
export var border = "_j6-8";
export var check = "_j6-h";
export var danger = "_j6-6";
export var dropdownContainer = "_j6-1";
export var editModalBody = "_j6-j";
export var footerContainer = "_j6-i";
export var fullWidth = "_j6-a";
export var hide = "_j6-9";
export var icon = "_j6-3";
export var input = "_j6-7";
export var inputFlex = "_j6-b";
export var inputWrapper = "_j6-c";
export var manualFocus = "_j6-5";
export var optionButton = "_j6-4";
export var pillWrapper = "_j6-e";
export var pointer = "_j6-2";
export var showOverflow = "_j6-f";
export var tagsFlex = "_j6-d";
export var xButton = "_j6-g";